export default __webpack_public_path__ + "efb96350c32a8d3b5945f6071443e070.png";